module.exports = __webpack_public_path__ + "static/media/pic7.754a708f.jpg";